<template lang="html">

  <div class="quienes-somos">

    <section class="middle-intro row-start">

      <div class="container">
        <h1 class="title -intro">{{$t('quienesSomos.slider.title')}}</h1>
        <img :src="$t('quienesSomos.slider.gif')" class="imagen-animacion" alt="imagen animacion">
      </div>

    </section>

    <section class="textos">

      <div class="container title-intro">

        <h2 class="title">{{$t('quienesSomos.title')}}</h2>

      </div>

      <div class="first-text">

        <p><strong>{{$t('quienesSomos.entradilla1')}}</strong></p>
        <p><strong>{{$t('quienesSomos.entradilla1_1')}}</strong></p>

        <p>{{$t('quienesSomos.entradilla2')}}</p>

        <div class="contenedor-imagen animate row-end">
          <img src="/static/img/quienes-somos-1.jpg" alt="Quienes somos">
        </div>

      </div>

      <div class="second-text">

        <p>{{$t('quienesSomos.description')}}</p>

        <div class="contenedor-imagen animate row-start">
          <img src="/static/img/quienes-somos-2.jpg" alt="Quienes somos 2">
        </div>


      </div>
      <!-- <div class="imagen-logos">
        <img src="/static/img/fundae.png" alt="Quienes somos 2">
        <img src="/static/img/logo-sepe.png" alt="Quienes somos 2">

      </div> -->
      <div class="contenedor-boton">
        <!-- <a href="" class="btn-rounded-blue">{{$t('moreInfo')}}</a> -->
      </div>

    </section>


  </div>

</template>

<script lang="js">
  export default {
    name: 'quienes-somos',

    props: [],

    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<style scoped>
  .middle-intro .title.-intro {
    color: #41566d;
  }

  .title-intro {
    text-align: left;
    padding: 20px 40px 50px 40px;
  }

  .title-intro .title {
    max-width: 480px;
    color: #3374b0;
  }

  @media screen and (min-width: 2250px) {
    .imagen-logos {
      display: flex !important;
      justify-content: flex-start !important;
    }
  }

  .first-text {
    width: 100%;
    padding: 100px 7% 100px 57%;
    text-align: left;
    background: rgba(51, 116, 176, 0.2);
    color: #1d1d1d;
    position: relative;
    margin-top: 100px;
  }

  p {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 28px;
    font-weight: 300;
  }

  .first-text p:last-of-type {
    margin-bottom: 0;
  }

  .first-text p strong {
    font-weight: 700;
  }

  .first-text .contenedor-imagen {
    position: absolute;
    width: 50%;
    background: #41566d;
    left: 0;
    top: -100px;
  }

  .first-text .contenedor-imagen::before {
    background: #41566d;
  }

  .first-text .contenedor-imagen img {
    max-width: 580px;
  }

  .second-text {
    background: #3374b0;
    display: inline-block;
    text-align: right;
    color: white;
    padding: 100px 43% 100px 7%;
    width: 100%;
    position: relative;
  }

  .second-text p {
    max-width: 580px;
    display: inline-block;
    text-align: left;
  }

  .second-text+.contenedor-boton {
    padding: 100px 0;
    max-width: 64%;
    text-align: center;
  }

  .second-text .contenedor-imagen {
    position: absolute;
    width: 36%;
    background: #41566d;
    right: 0;
    top: 100px;
  }

  .second-text .contenedor-imagen {
    transform: translateX(110%);
  }

  .second-text .contenedor-imagen.active {
    transform: translateX(0%);
  }

  .second-text .contenedor-imagen::before {
    background: #41566d;
  }

  .second-text .contenedor-imagen.active::before {
    transform: translateX(110%);
  }



  .second-text .contenedor-imagen img {
    max-width: 600px;
  }

  @media screen and (max-width: 1000px) {

    p {
      margin-bottom: 20px;
    }

    .first-text .contenedor-imagen {
      display: none;
    }

    .first-text {
      padding: 50px 7%;
      margin-top: 0;
    }

    .middle-intro {
      margin-bottom: 0;
    }

  }

  @media screen and (max-width: 600px) {

    .second-text,
    .first-text,
    .title-intro {
      padding: 50px 15px;
    }

    .second-text .contenedor-imagen {
      display: none;
    }

    .second-text+.contenedor-boton {
      padding: 50px 0;
      max-width: 100%;
    }


  }
</style>


// WEBPACK FOOTER //
// src/components/views/quienes-somos.vue